import styled, { css } from 'styled-components';

const paddingProperties = ['$padding', '$pt', '$pr', '$pb', '$pl'];
const marginProperties = ['$margin', '$mt', '$mr', '$mb', '$ml'];
const layoutProperties = [
    '$display',
    '$opacity',
    '$alignItems',
    '$flexDirection',
    '$justifyContent',
    '$flex',
    '$position',
    '$width',
    '$height',
    '$top',
    '$right',
    '$bottom',
    '$left',
    '$gap',
];
const appearanceProperties = ['$color', '$backgroundColor'];
const blackListedCss = ['opacity', 'z-index'];
const composeCss = (props) => {
    return Object.entries(props)
        .filter(([property]) => {
        const key = property;
        return [
            ...paddingProperties,
            ...marginProperties,
            ...layoutProperties,
            ...appearanceProperties,
        ].includes(key);
    })
        .filter(([, value]) => value !== undefined)
        .map(([property, value]) => {
        const convertedProperty = property
            .replace('$', '')
            .replace(/([a-z])([A-Z])/g, '$1-$2')
            .toLowerCase();
        const shouldIgnore = blackListedCss.includes(convertedProperty);
        const convertedValue = !shouldIgnore && typeof value === 'number' ? `${value}px` : value;
        return [convertedProperty, convertedValue];
    })
        .map(([property, value]) => {
        if (['mt', 'mr', 'mb', 'ml', 'pt', 'pr', 'pb', 'pl'].includes(String(property))) {
            const convertedName = {
                mt: 'margin-top',
                mr: 'margin-right',
                mb: 'margin-bottom',
                ml: 'margin-left',
                pt: 'padding-top',
                pr: 'padding-right',
                pb: 'padding-bottom',
                pl: 'padding-left',
            }[property];
            return [convertedName, value];
        }
        return [property, value];
    })
        .map(([property, value]) => `${property}: ${value};`);
};
const Box = styled.div `
  ${props => {
    const styles = composeCss(props).join('\n');
    return css `
      ${styles}
    `;
}}
`;
Box.displayName = 'Box';

export { Box, composeCss };
//# sourceMappingURL=styled.js.map
